export default () => ({
  handler: 'relativeUrl',
  data: ({ path, mobileSlug }) => `/pages/${path || mobileSlug}`,
});
